import { createSlice } from '@reduxjs/toolkit';
import { logoutUser } from '@/store/slices/authSlice';
import { creativeService } from '@/services/creativeService'; // o '@/services/creative' dependiendo de tu archivo
import {
  CreativeDimensionItem,
  CreativeDimensionsRankParams,
  CreativeDimensionsByBrand,
  CreativeDimensionsByBrandParams,
} from '@/types/creative.types';
import {
  DataStateWithParams,
  createDataAsyncThunk,
  addDataAsyncCasesWithParams,
} from '@/store/utils/asyncThunkHelpers';

interface CreativeState {
  dimensionsRank: DataStateWithParams<CreativeDimensionItem[], CreativeDimensionsRankParams>;
  dimensionsByBrand: DataStateWithParams<
    CreativeDimensionsByBrand,
    CreativeDimensionsByBrandParams
  >;
}

const initialState: CreativeState = {
  dimensionsRank: { data: null, status: 'idle', error: null },
  dimensionsByBrand: { data: null, status: 'idle', error: null },
};

export const fetchCreativeDimensionsRank = createDataAsyncThunk<
  CreativeDimensionItem[],
  CreativeDimensionsRankParams
>('creative/fetchCreativeDimensionsRank', creativeService.getCreativeDimensionsRank);

export const fetchCreativeDimensionsByBrand = createDataAsyncThunk<
  CreativeDimensionsByBrand,
  CreativeDimensionsByBrandParams
>('creative/fetchCreativeDimensionsByBrand', creativeService.getCreativeDimensionsByBrand);

const creativeSlice = createSlice({
  name: 'creative',
  initialState,
  reducers: {},
  extraReducers: builder => {
    addDataAsyncCasesWithParams(
      builder,
      fetchCreativeDimensionsRank,
      state => state.dimensionsRank
    );
    addDataAsyncCasesWithParams(
      builder,
      fetchCreativeDimensionsByBrand,
      state => state.dimensionsByBrand
    );

    builder.addCase(logoutUser.fulfilled, () => {
      return initialState;
    });
  },
});

export default creativeSlice.reducer;
